// extracted by mini-css-extract-plugin
export default {"content":"noData_content__Ck2+m"};